import React from 'react';

import { Box, Popover, Tooltip } from '@mui/material';

import type { GetUserQuery } from '../../../gql/graphql';

import { UserMenuButton } from './UserMenuButton/UserMenuButton';
import { UserMenuCard } from './UserMenuCard/UserMenuCard';

type UserMenuProps = {
  data: GetUserQuery | undefined;
  handleOpenPopover: (event: React.MouseEvent<HTMLElement>) => void;
  anchorElUser: HTMLElement | null;
  handleClosePopover: () => void;
  handleLogin: () => void;
  handleLogout: () => void;
  selected: boolean;
};

export const UserMenu = (props: UserMenuProps) => {
  const open = Boolean(props.anchorElUser);
  const id = open ? 'user-account-popover' : undefined;
  return (
    <Box sx={{ display: 'flex', minHeight: '100%', alignItems: 'center' }}>
      <Tooltip title="Open user menu" sx={{ display: 'flex' }}>
        <UserMenuButton data={props.data} handleOpenPopover={props.handleOpenPopover} selected={props.selected} />
      </Tooltip>
      <Popover
        slotProps={{ root: { id: id } }}
        open={open}
        anchorEl={props.anchorElUser}
        onClose={props.handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <UserMenuCard {...props} />
      </Popover>
    </Box>
  );
};
